import Attribute, { Type } from './Attribute';

/*
	The seven attributes React reads off Tools.SoliditetClient.attr (WEB-8568). The Angular service
	at upsales/common/attributes/soliditetClient.js declares many more, but nothing outside the
	Angular tree touches them, so they are left there to die with it.

	displayType is omitted: the Attribute helper defaults it, and no consumer of these reads it.
*/
const SoliditetClientAttributes = {
	dunsNo: Attribute({ title: 'tag.account.dunsNo', field: 'dunsNo', type: Type.Number, sortable: 'dunsNo' }),
	name: Attribute({ title: 'default.accountName', field: 'name', type: Type.String, sortable: 'name' }),
	orgNo: Attribute({ title: 'default.orgNo', field: 'orgNo', type: Type.Number }),
	country: Attribute({ title: 'address.country', field: 'country', type: Type.String }),
	headquarters: Attribute({ title: 'default.headquarters', field: 'headquarters', type: Type.Boolean }),
	status: Attribute({ title: 'default.status', field: 'status', type: Type.String }),
	rootParentDuns: Attribute({ title: 'default.rootParentDuns', field: 'rootParentDuns', type: Type.Number })
};

export default SoliditetClientAttributes;
